import { Space } from 'antd';
import ModelConfiguratorBannerForm from './ModelConfiguratorBannerForm';
import ModelConfiguratorPageForm from './ModelConfiguratorPageForm';
import ModelConfiguratorSetupForm from './ModelConfiguratorSetupForm';

export type ModelConfiguratorFormProps = {
    isEdit?: boolean;
    updated?: string;
    offset?: string;
    disabled?: boolean;
};

const ModelConfiguratorForm = ({ isEdit, updated, offset, disabled = false }: ModelConfiguratorFormProps) => (
    <Space direction="vertical" style={{ width: '100%' }}>
        {!isEdit && <ModelConfiguratorSetupForm />}
        <ModelConfiguratorPageForm disabled={disabled} isEdit={isEdit} offset={offset} updated={updated} />
        <ModelConfiguratorBannerForm disabled={disabled} />
    </Space>
);

export default ModelConfiguratorForm;

export { default as useModelConfiguratorFormValidator } from './useModelConfiguratorFormValidator';
export { default as useHandleModelConfiguratorAssets } from './useHandleModelConfiguratorAssets';
export * from './utils';
